import { Component, Input, OnInit } from '@angular/core';
import { ILayoutSettings, IPageContent } from '@app/feature/store-editor/components/layout/store-editor.interface';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SLIDERComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
 
  constructor() { }

  ngOnInit() {
  }

  addUrl(image: string) {
    return 'url("' + image + '")';
  }

  getCurrentSlide() {
    return this.item.data.images.findIndex(x => x.active);
  }

  nextSlide() {
    const current = this.getCurrentSlide();

    if (current < this.item.data.images.length - 1) {
      this.item.data.images[current].active = false;
      this.item.data.images[current + 1].active = true;
      const translateAmount = -1 * ((current + 1) * 100);
      this.item.data.images.forEach((x, index) => this.item.data.images[index].translateX = translateAmount);
    } else {
      this.item.data.images[current].active = false;
      this.item.data.images[0].active = true;
      this.item.data.images.forEach((x, index) => this.item.data.images[index].translateX = 0);
    }
  }

  prevSlide() {
    const current = this.getCurrentSlide();
    const sliderLength = this.item.data.images.length;
    if (current > 0) {
      this.item.data.images[current].active = false;
      this.item.data.images[current - 1].active = true;
      const translateAmount = -1 * ((current - 1) * 100);
      this.item.data.images.forEach((x, index) => this.item.data.images[index].translateX = translateAmount);
    } else {
      this.item.data.images[current].active = false;
      this.item.data.images[sliderLength - 1].active = true;
      this.item.data.images.forEach((x, index) => this.item.data.images[index].translateX = -1 * (sliderLength - 1) * 100);
    }
  }
}
